<template>
<component :is="tag">
    <slot/>
</component>


</template>
<script>
//
//
//
//
//
//
//
import { debounce } from 'lodash'; // 兼容浏览器

if (typeof window !== 'undefined') {
  require('intersection-observer');
}

export default {
  props: {
    tag: {
      type: [String, Object],
      default: 'div'
    },
    // 超出多少比例开始加载图片
    ratio: {
      // 可选值 0 / 0.25 / 0.5 / 0.75 / 1
      type: Number,
      default: 0.6
    },
    // 持续时长
    time: {
      type: Number,
      default: 1500
    },
    exposable: {
      type: Function,
      default: function _default() {
        return true;
      }
    },
    // 是否多次触发
    multipe: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      intersectionObserver: null
    };
  },

  mounted() {
    var _this = this;

    if (!this.intersectionObserver) {
      this.intersectionObserver = new IntersectionObserver(debounce(function (entries) {
        entries.forEach(function (e) {
          if (!_this.multipe && (!_this.exposable() || _this.exposed)) return;

          if (e.intersectionRatio >= _this.ratio) {
            if (_this.time > 0) {
              clearTimeout(_this.timer);
              _this.timer = setTimeout(function () {
                _this.$emit('expose');

                _this.exposed = true;
                !_this.multipe && _this.intersectionObserver.unobserve(e.target);
              }, _this.time);
            } else {
              _this.intersectionObserver.unobserve(e.target);
            }
          } else {
            if (_this.timer) clearTimeout(_this.timer);
          }
        });
      }, 100), {
        threshold: [0, 0.25, 0.5, 0.6, 0.75, 1]
      });
    }

    this.intersectionObserver.observe(this.$el);
  },

  beforeDestroy() {
    this.intersectionObserver.unobserve(this.$el);
  },

  methods: {
    expose() {
      if (this.exposed || !this.exposable()) return;
      this.intersectionObserver.unobserve(this.$el);
      this.intersectionObserver.observe(this.$el);
    }

  }
};
</script>
